var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 100,
    r: 15,
    fill: "#3799CB",
    stroke: "#3799CB",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: -0.4,
    calcMode: "spline",
    dur: 1.3,
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    values: "1;0;1;"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 15,
    fill: "#3799CB",
    stroke: "#3799CB",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: -0.2,
    calcMode: "spline",
    dur: 1.3,
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    values: "1;0;1;"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 100,
    r: 15,
    fill: "#3799CB",
    stroke: "#3799CB",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: 0,
    calcMode: "spline",
    dur: 1.3,
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    values: "1;0;1;"
  }))));
};
export default SvgLoading;